import React, { Component } from 'react';
import './Recommendations.css';
import EditBar from '../EditBar/EditBar';

class Recommendations extends Component {
  toggleEditing(toggle) {
    if (this.props.onToggleEditing) {
      this.props.onToggleEditing(toggle);
    }
  }

  render() {
    const {
      sectionIndex,
      contentBlockIndex,
      removeContentBlock,
      recommendationsType,
      recommendationsValue
    } = this.props;

    return (
      <div className={`recommendations edit-wrapper text-center`}>
        <h3>Recommendations</h3>
        <p>
          <strong>Type</strong>: {recommendationsType}
        </p>
        <p>
          <strong>Value</strong>: {recommendationsValue}
        </p>
        <EditBar
          toggleEditing={() => this.toggleEditing(true)}
          removeContentBlock={() =>
            removeContentBlock(sectionIndex, contentBlockIndex)
          }
        />
      </div>
    );
  }
}

export default Recommendations;



// WEBPACK FOOTER //
// ./src/components/landingPage/Recommendations/Recommendations.js